import { Children } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards, FreeMode, Keyboard, Mousewheel, Navigation, Pagination } from 'swiper';
import { Svg } from '../Svg';
import { IVfSwiper } from './vfSwiper.models';
import * as S from './vfSwiper.style';
import { useVfSwiper } from './vfSwiper.hook';

export const VfSwiper: React.FC<IVfSwiper> = ({
  bulletActiveClass = 'swiper-pagination-bullet-active',
  bulletClass = 'swiper-pagination-bullet',
  centeredSlides = true,
  children,
  effect,
  freeMode,
  navigation = false,
  navigationAlign = 'flex-start',
  noSwipingSelector,
  pagination = true,
  slideWidth,
  spaceBetween = 32,
  slidesPerView = 'auto',
  styled,
}) => {
  const { navigationPrevRef, navigationNextRef, onSwiper, slidePrev, slideNext } = useVfSwiper();

  return (
    <S.SwiperWrapper pagination={pagination} slideWidth={slideWidth} styled={styled}>
      {navigation && (
        <S.Navigation navigationAlign={navigationAlign}>
          <S.IconButton onClick={slidePrev} ref={navigationPrevRef} type="button">
            <Svg name="chevronLeft" width={26} />
          </S.IconButton>
        </S.Navigation>
      )}
      <Swiper
        cardsEffect={{
          rotate: true,
          slideShadows: false,
        }}
        centeredSlides={centeredSlides}
        effect={effect}
        freeMode={freeMode}
        keyboard
        modules={[Navigation, Pagination, FreeMode, Mousewheel, Keyboard, EffectCards]}
        mousewheel={{
          forceToAxis: true,
        }}
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        noSwipingSelector={noSwipingSelector}
        onSwiper={onSwiper}
        pagination={{
          enabled: pagination,
          bulletClass,
          bulletActiveClass,
          clickable: true,
        }}
        preventInteractionOnTransition
        slidesPerView={slidesPerView}
        spaceBetween={spaceBetween || 0}
      >
        {Children.map(children, (child) => (
          <SwiperSlide>{child}</SwiperSlide>
        ))}
      </Swiper>
      {navigation && (
        <S.Navigation navigationAlign={navigationAlign}>
          <S.IconButton onClick={slideNext} ref={navigationNextRef} type="button">
            <Svg name="chevronRight" width={26} />
          </S.IconButton>
        </S.Navigation>
      )}
    </S.SwiperWrapper>
  );
};

